import { render, staticRenderFns } from "./Tab0.vue?vue&type=template&id=2dffba38"
import script from "./Tab0.vue?vue&type=script&lang=js"
export * from "./Tab0.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports